import { Box, Card } from "@mui/material";
import ClearwaysDeviceSettings from "components/Forms/ClearwaysDeviceSettings";
import DeviceSettingsForm from "components/Forms/DeviceSettings";
import PropTypes from "prop-types";

function DeviceSettingsTab({ uuid, device, tags, sites, user_type, raw, deviceLayout }) {

    console.log(tags)
    return (
        <Card sx={{ height: "100%", overflowY: 'auto' }}>
            {device.organisation_id == 'clearways' ? (
                <ClearwaysDeviceSettings uuid={uuid} selected_device={raw} user_type={user_type} deviceLayout={deviceLayout} />
            ) : (
                <DeviceSettingsForm selected_device={device} tags={tags} deviceLayout={deviceLayout} />
            )}
        </Card>
    );
}

DeviceSettingsTab.propTypes = {
    uuid: PropTypes.string,
    device: PropTypes.object,
    user_type: PropTypes.string,
    raw: PropTypes.object,
    deviceLayout: PropTypes.string
}

export default DeviceSettingsTab;